/* Core resolves native delivery and import amounts without
 * sending a reference address to the shopper's cookie cart or checkout. */
(function () {
  'use strict';
  // Shopify collection settings verified 27 October 2026; the non-collecting
  // Multi-Currency child excludes all parent regions except Bulgaria/Hungary.
  var importMarkets = {AT:'EUR',BE:'EUR',BG:'EUR',CY:'EUR',CZ:'CZK',DE:'EUR',DK:'DKK',EE:'EUR',ES:'EUR',FI:'EUR',FR:'EUR',GR:'EUR',HR:'EUR',HU:'HUF',IE:'EUR',IT:'EUR',LT:'EUR',LU:'EUR',LV:'EUR',MT:'EUR',NL:'EUR',PL:'PLN',PT:'EUR',RO:'RON',SE:'SEK',SI:'EUR',SK:'EUR',US:'USD'};
  var markets = Object.assign({GB:'GBP',CA:'CAD',AU:'AUD',CH:'CHF'},importMarkets);
  var state = {status:'idle',quote:null};
  var generation = 0, controller = null, timer = null, expiryTimer = null, validUntil = 0, fullCartLoading = false;
  var lastGood = null, pendingRequest = null, renewalTimer = null, customerContextEpoch = 0;
  var drawerSync = null, dispatchingDrawerSync = false;
  var fallbackReceipt = null, fallbackExpiryTimer = null;
  var retryAfterUntil = 0, recovering = false, recoveryAttempt = 0;
  var customerContextAway = document.visibilityState === 'hidden' || !document.hasFocus();
  function market() {
    return {country:String(window.Shopify && window.Shopify.country || '').toUpperCase(),
      currency:String(window.Shopify && window.Shopify.currency && window.Shopify.currency.active || '').toUpperCase()};
  }
  function candidate() {
    return window.dsrcvCartServerQuotesEnabled === true || (window.Shopify && window.Shopify.theme && String(window.Shopify.theme.id) === '186928333178' && window.Shopify.theme.role !== 'main');
  }
  function active() {var m = market(); return candidate() && markets[m.country] === m.currency;}
  function drawerMatchesCart(cart) {
    var drawer = document.getElementById('sidebar-cart');
    if (!drawer || document.querySelector('.Cart__Recap')) return true;
    var rows = drawer.querySelectorAll('[data-native-ucd-line-key]');
    if (rows.length !== cart.items.length) return false;
    var totals = drawer.querySelector('[data-native-ucd-merchandise-total]');
    var amount = totals && totals.getAttribute('data-native-ucd-merchandise-total');
    if (!rows.length) return cart.total_price === 0 && (!totals || amount === '0');
    if (!/^\d+$/.test(amount || '') || Number(amount) !== cart.total_price) return false;
    var keys = Array.prototype.map.call(rows,function (row) {return row.getAttribute('data-native-ucd-line-key');});
    if (new Set(keys).size !== rows.length) return false;
    return Array.prototype.every.call(rows,function (row) {
      return cart.items.some(function (item) {
        return item.key === row.getAttribute('data-native-ucd-line-key') &&
          String(item.variant_id) === row.getAttribute('data-native-ucd-variant-id') &&
          String(item.quantity) === row.getAttribute('data-native-ucd-item-quantity');
      });
    });
  }
  function syncDrawerReceipt(cart, signal) {
    if (signal.aborted) return Promise.reject(new Error('timeout'));
    if (drawerMatchesCart(cart)) return Promise.resolve();
    if (drawerSync) return drawerSync.promise;
    var entry = {}, drawer = document.getElementById('sidebar-cart');
    entry.promise = new Promise(function (resolve,reject) {
      var watcher, deadline, finished = false;
      function finish(error) {
        if (finished) return;finished = true;
        watcher.disconnect();clearTimeout(deadline);signal.removeEventListener('abort',aborted);
        if (drawerSync === entry) drawerSync = null;
        if (error) reject(error);else resolve();
      }
      function aborted() {finish(new Error('timeout'));}
      watcher = new MutationObserver(function () {if (drawerMatchesCart(cart)) finish();});
      watcher.observe(drawer,{childList:true,subtree:true,attributes:true});
      deadline = setTimeout(function () {var error = new Error('drawer');error.retryable = true;finish(error);},5000);
      signal.addEventListener('abort',aborted,{once:true});
    });
    drawerSync = entry;
    // Ask the native cart renderer to replace its receipt, without changing
    // merchandise. Do not restart this generation for our own refresh event.
    dispatchingDrawerSync = true;
    try {document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));}
    finally {dispatchingDrawerSync = false;}
    return entry.promise;
  }
  function quoteProperties(item) {
    var raw = item.properties || {}, result = {};
    if (typeof raw !== 'object' || Array.isArray(raw)) return null;
    var allowed = ['Notice','_Pre-order','_preorder_preview','_preorder_batch','_preorder_variant','_preorder_despatch_start','_preorder_despatch_end','_preorder_ship_date','_preorder_window','_preorder_checkout'];
    var keys = Object.keys(raw).sort();
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i], value = raw[key];
      if (key === '__ucd') {
        // Native recommendations mark their origin without changing merchandise.
        // Normalize only the exact marker in quote input, never the cookie cart.
        if (value === 'true' && !keys.some(function (name) {return name.indexOf('_preorder_') === 0;})) continue;
        return null;
      }
      if (key === '__Sale_Item') {
        // This storefront marker does not change the quoted merchandise.
        // Keep private rehearsal receipts exact and leave the cookie cart intact.
        if (value === 'Yes' && !keys.some(function (name) {return name.indexOf('_preorder_') === 0;})) continue;
        return null;
      }
      if (value === '') continue;
      if (allowed.indexOf(key) === -1 || typeof value !== 'string' || !value.trim() || value.length > 512 || /[\u0000-\u001f\u007f]/.test(value)) return null;
      result[key] = value;
    }
    if (Object.keys(result).some(function (key) {return key.indexOf('_preorder_') === 0;})) {
      var batches = [
        ['16247074029946','57448473362810,57448473395578,57448473428346,57448473461114,57448473493882','2027-01-06','2027-01-13','6–13 January 2027','January 13, 2027'],
        ['16247074128250','57448473919866,57448473952634,57448473985402,57448474018170,57448474050938','2027-01-13','2027-01-20','13–20 January 2027','January 20, 2027'],
        ['16247074226554','57448474116474,57448474149242,57448474182010,57448474214778,57448474247546','2027-01-20','2027-01-27','20–27 January 2027','January 27, 2027'],
        ['16247074292090','57448474313082,57448474345850,57448474378618,57448474411386','2027-01-06','2027-01-13','6–13 January 2027','January 13, 2027']
      ];
      var batch = batches.find(function (entry) {return entry[0] === String(item.product_id) && entry[1].split(',').indexOf(String(item.variant_id)) !== -1;});
      if (!batch) return null;
      var expected = {Notice:'Estimated shipping date is ' + batch[5],_preorder_preview:'private-rehearsal-20261022',_preorder_batch:'private-test-20261022-' + batch[0],_preorder_variant:String(item.variant_id),_preorder_despatch_start:batch[2],_preorder_despatch_end:batch[3],_preorder_ship_date:batch[3],_preorder_window:batch[4],_preorder_checkout:'ordinary-full-payment-rehearsal'};
      if (Object.keys(result).length !== Object.keys(expected).length || Object.keys(expected).some(function (key) {return result[key] !== expected[key];})) return null;
    }
    // Core verifies catalogue and receipt metadata again; this does not grant
    // stock availability or turn an actual selling plan into an ordinary line.
    return result;
  }
  function shippingQuote(q, count, status) {
    if (window.dsrcvCartShipping && window.dsrcvCartShipping.setPreviewQuote) window.dsrcvCartShipping.setPreviewQuote(q,count,status,q ? validUntil : null);
  }
  function money(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency', currencyDisplay: 'narrowSymbol',currency:currency,minimumFractionDigits:cents % 100 ? 2 : 0,maximumFractionDigits:2}).format(cents / 100);
  }
  function text(el, value) {if (el.textContent !== value) el.textContent = value;}
  function importLabel(row) {
    var copy = document.createElement('div');
    copy.style.cssText = 'flex:1;min-width:0';
    var details = document.createElement('details'), summary = document.createElement('summary'), note = document.createElement('div');
    summary.style.cssText = 'display:inline-flex;align-items:center;gap:5px;list-style:none;cursor:pointer';
    var label = document.createElement('span'), icon = document.createElement('span');
    label.textContent = 'Import charges'; icon.textContent = 'ⓘ'; icon.setAttribute('aria-hidden','true');
    summary.append(label,icon);
    note.className = 'NativeUcdDrawer__ShippingNote';
    note.textContent = 'Duties and import taxes are collected at checkout. This estimate is based on the items in your bag and your selected country.';
    note.style.cssText = 'margin:6px 0 0;padding:8px 10px;background:#f5f5f5;border-radius:4px;font-size:11px;line-height:1.4';
    var confirmation = reassurance('data-duties-preview-reassurance');
    confirmation.style.cssText = 'margin:0 0 4px;font:inherit;color:inherit';
    note.prepend(confirmation);
    details.append(summary,note);
    copy.append(details);
    row.appendChild(copy);
  }
  function reassurance(attribute) {
    var note = document.createElement('p');
    note.setAttribute(attribute,'');
    note.className = 'NativeUcdDrawer__ShippingNote';
    note.textContent = 'No extra import charges on delivery';
    note.style.cssText = 'margin:4px 0 0;font-size:11px;line-height:1.4';
    note.hidden = true;
    return note;
  }
  function totalReassurance(container, visible) {
    var note = container.querySelector('[data-duties-preview-total-reassurance]');
    if (!note && visible) {
      note = reassurance('data-duties-preview-total-reassurance');
      var amount = container.querySelector('[data-native-ucd-total]');
      var rows = container.querySelectorAll('[data-preview-recap-amount]');
      var totalRow = amount ? amount.parentElement : rows.length ? rows[rows.length - 1].parentElement : null;
      if (!totalRow) return;
      totalRow.insertAdjacentElement('afterend',note);
    }
    if (note) note.hidden = !visible;
  }
  function clearFallbackReceipt() {
    fallbackReceipt = null;clearTimeout(fallbackExpiryTimer);
  }
  function retireExpiredQuote() {
    if (!state.quote || Date.now() < validUntil) return;
    generation++;state = {status:'unavailable',quote:null};validUntil = 0;
    clearTimeout(expiryTimer);clearTimeout(renewalTimer);
    if (controller && (!pendingRequest || pendingRequest.controller !== controller)) controller.abort();
    shippingQuote(null,null,'error');
    recover(0,250);
  }
  function checkoutFallback() {
    retireExpiredQuote();
    if (!active() || state.status !== 'unavailable') return null;
    var m = market(), entry = fallbackReceipt;
    var cart = entry && entry.country === m.country && entry.currency === m.currency &&
      entry.customerEpoch === customerContextEpoch && Date.now() < entry.expiresAt &&
      drawerMatchesCart(entry.cart) ? entry.cart : null;
    return {country:m.country,currency:m.currency,subtotalCents:cart ? cart.total_price : null,
      dutiesIncluded:cart ? cart.duties_included === true : null,importsRequired:!!importMarkets[m.country]};
  }
  function renderFallback(container, fallback, recap) {
    var note = container.querySelector('[data-cart-checkout-fallback]');
    if (!fallback) {if (note) note.hidden = true;return;}
    var amounts = recap && container.querySelectorAll('[data-preview-recap-amount]');
    var total = recap ? amounts[2] : container.querySelector('[data-native-ucd-total]');
    var label = recap ? total && total.previousElementSibling : container.querySelector('[data-native-ucd-total-label]');
    if (label) text(label,fallback.subtotalCents === null ? 'Order total' : 'Subtotal');
    if (total) {
      total.removeAttribute('data-money-convertible');
      text(total,fallback.subtotalCents === null ? 'Calculated at checkout' : money(fallback.subtotalCents,fallback.currency));
    }
    if (recap) text(amounts[0],'Calculated at checkout');
    else {
      container.querySelectorAll('[data-native-ucd-shipping-price]').forEach(function (amount) {
        text(amount,'Calculated at checkout');amount.classList.remove('is-free');
      });
      container.querySelectorAll('[data-native-ucd-shipping-status]').forEach(function (status) {
        status.hidden = true;status.classList.add('is-hidden');
      });
    }
    if (!note && total) {
      note = document.createElement('p');note.setAttribute('data-cart-checkout-fallback','');
      note.className = 'NativeUcdDrawer__ShippingNote';note.style.cssText = 'margin:6px 0 0;font-size:12px;line-height:1.4';
      total.parentElement.insertAdjacentElement('afterend',note);
    }
    if (note) {
      text(note,fallback.importsRequired && fallback.dutiesIncluded !== true
        ? 'Delivery and any applicable import charges are calculated at checkout.' : 'Delivery is calculated at checkout.');
      note.hidden = false;
    }
  }
  function render() {
    retireExpiredQuote();
    if (state.quote && lastGood && lastGood.receipt && !drawerMatchesCart(lastGood.receipt)) {invalidate();schedule(false);return;}
    var m = market(), shipping = window.dsrcvCartShipping && window.dsrcvCartShipping.getState();
    var rate = shipping && shipping.rate, q = state.quote;
    var fallback = checkoutFallback();
    var show = active() && importMarkets[m.country] && state.status !== 'included' && !(fallback && fallback.dutiesIncluded);
    var shippingReady = active() && Date.now() < validUntil && q && rate && q.country === m.country && q.currency === m.currency && rate.countryCode === m.country && rate.currency === m.currency && q.shippingCents === rate.priceCents && q.shippingService === rate.methodLabel && q.subtotalCents === rate.subtotalCents;
    var ready = show && state.status === 'ready' && shippingReady && q.dutiesEstimated === true;
    var shippingOnlyReady = shippingReady && (state.status === 'shipping_only' || state.status === 'included');
    document.querySelectorAll('.NativeUcdDrawer__Totals').forEach(function (totals) {
      var row = totals.querySelector('[data-duties-preview-row]');
      if (!show || totals.querySelector('[data-native-ucd-duties-row]')) {
        if (row) row.hidden = true;
        totalReassurance(totals,!!(shippingOnlyReady && state.status === 'included' && m.country !== 'GB'));
        if (candidate() && (row || totals.querySelector('[data-cart-checkout-fallback]')) && !fallback) {
          var baseLabel = totals.querySelector('[data-native-ucd-total-label]'), baseTotal = totals.querySelector('[data-native-ucd-total]');
          if (baseLabel) text(baseLabel,'Total');
          if (baseTotal) text(baseTotal,rate && rate.countryCode === m.country && rate.currency === m.currency ? money(rate.subtotalCents + rate.priceCents,m.currency) : '—');
        }
        renderFallback(totals,fallback,false);return;
      }
      var total = totals.querySelector('[data-native-ucd-total]'), label = totals.querySelector('[data-native-ucd-total-label]');
      if (!row) {
        row = document.createElement('div'); row.className = 'NativeUcdDrawer__TotalRow'; row.setAttribute('data-duties-preview-row','');
        var amount = document.createElement('span'); importLabel(row); amount.setAttribute('data-duties-preview-amount',''); row.appendChild(amount);
        totals.insertBefore(row,label && label.parentElement || null);
      }
      row.hidden = false;
      row.querySelector('[data-duties-preview-reassurance]').hidden = !ready;
      totalReassurance(totals,false);
      text(row.querySelector('[data-duties-preview-amount]'),ready ? money(q.importChargesCents,m.currency) : fallback ? 'Calculated at checkout' : state.status === 'pending' ? 'Checking…' : 'At checkout');
      if (label && !fallback) text(label,'Total');
      if (total && !fallback) {total.removeAttribute('data-money-convertible');text(total,ready ? money(q.totalCents,m.currency) : '—');}
      renderFallback(totals,fallback,false);
    });
    document.querySelectorAll('.Cart__Recap').forEach(function (recap) {
      var group = recap.querySelector('[data-duties-preview-recap]'), original = recap.querySelector('.Cart__Total');
      if (!active()) {if (group) group.hidden = true; if (original) original.hidden = false; return;}
      if (!group) {
        group = document.createElement('div'); group.setAttribute('data-duties-preview-recap','');
        group.style.cssText = 'width:100%;max-width:360px;margin:0 0 20px auto;text-align:left;font-size:14px;line-height:1.5';
        ['Delivery','Import charges','Total'].forEach(function (label) {
          var row = document.createElement('div'); row.className = 'NativeUcdDrawer__TotalRow';
          row.style.cssText = 'display:flex;justify-content:space-between;align-items:baseline;gap:16px;margin:8px 0';
          var name = document.createElement('span'), amount = document.createElement('span');
          if (label === 'Import charges') importLabel(row); else {name.textContent = label;row.appendChild(name);}
          amount.style.flexShrink = '0';
          if (label === 'Total') row.style.fontWeight = '500';
          amount.setAttribute('data-preview-recap-amount','');row.appendChild(amount);group.appendChild(row);
        });
        recap.insertBefore(group,original || recap.firstChild);
      }
      group.hidden = false;if (original) original.hidden = true;
      var amounts = group.querySelectorAll('[data-preview-recap-amount]');
      amounts[1].parentElement.hidden = !show;
      amounts[1].parentElement.style.display = show ? 'flex' : 'none';
      group.querySelector('[data-duties-preview-reassurance]').hidden = !ready;
      totalReassurance(group,!!(!show && shippingOnlyReady && state.status === 'included' && m.country !== 'GB'));
      text(amounts[0],fallback ? 'Calculated at checkout' : shippingReady ? q.shippingCents === 0 ? 'Free' : money(q.shippingCents,m.currency) : state.status === 'pending' ? 'Checking…' : 'At checkout');
      text(amounts[1],ready ? money(q.importChargesCents,m.currency) : fallback ? 'Calculated at checkout' : state.status === 'pending' ? 'Checking…' : 'At checkout');
      if (!fallback) {
        text(amounts[2].previousElementSibling,'Total');
        text(amounts[2],ready ? money(q.totalCents,m.currency) : shippingOnlyReady ? money(q.subtotalCents + q.shippingCents,m.currency) : '—');
      }
      renderFallback(group,fallback,true);
    });
  }
  function invalidate() {
    clearFallbackReceipt();
    generation++;state = {status:'pending',quote:null};validUntil = 0;clearTimeout(expiryTimer);clearTimeout(renewalTimer);
    recovering = false;
    if (controller && (!pendingRequest || pendingRequest.controller !== controller)) controller.abort();
    shippingQuote(null,null,'pending');render();
  }
  function refreshCustomerContext() {
    customerContextEpoch++;lastGood = null;
    if (fullCartLoading) {clearTimeout(timer);invalidate();return;}
    schedule(true);
  }
  function restoreCustomerContext() {
    if (!customerContextAway) return;
    customerContextAway = false;refreshCustomerContext();
  }
  function useQuote(entry, count, renew) {
    if (Date.now() >= entry.validUntil) {invalidate();schedule(false);return;}
    if (entry.receipt && !drawerMatchesCart(entry.receipt)) {invalidate();schedule(false);return;}
    recovering = false;validUntil = entry.validUntil;state = {status:entry.status,quote:entry.quote};
    shippingQuote(entry.quote,count);render();clearTimeout(expiryTimer);clearTimeout(renewalTimer);
    expiryTimer = setTimeout(retireExpiredQuote,Math.max(0,validUntil - Date.now()));
    // Only the server's stable quote identity can prove a new calculation.
    // Older servers keep their existing expiry behaviour until upgraded.
    if (renew !== false && entry.quoteId && validUntil - Date.now() > 10000) {
      renewalTimer = setTimeout(function () {
        if (document.visibilityState === 'visible' && lastGood === entry && Date.now() < validUntil) refresh(0,entry);
      },validUntil - Date.now() - 10000);
    }
  }
  function recover(attempt, delay) {
    recovering = true;recoveryAttempt = attempt;clearTimeout(timer);
    // A hidden/offline page resumes through its existing visibility/online
    // handlers. Do not spend the provider budget while the shopper is away.
    if (document.visibilityState === 'hidden' || navigator.onLine === false) return;
    timer = setTimeout(function () {
      if (document.visibilityState !== 'hidden' && navigator.onLine !== false) refresh(attempt);
    },Math.min(60000,Math.max(delay,retryAfterUntil - Date.now())));
  }
  function rateLimitDeadline(response) {
    var value = response.headers && response.headers.get('Retry-After');
    var seconds = value && /^\d+(?:\.\d+)?$/.test(value.trim()) ? Number(value) : NaN;
    var delay = Number.isFinite(seconds) ? seconds * 1000 : Date.parse(value) - Date.now();
    // Older Core responses omit Retry-After; its client window is one minute.
    return Date.now() + (Number.isFinite(delay) && delay > 0 ? delay : 60000);
  }
  async function refresh(attempt, renewal) {
    if (renewal && (lastGood !== renewal || state.quote !== renewal.quote || Date.now() >= validUntil)) return;
    if (active() && Date.now() < retryAfterUntil) {
      if (state.status !== 'ready' && state.status !== 'shipping_only' && state.status !== 'included') {
        state = {status:'unavailable',quote:null};shippingQuote(null,null,'error');render();
      }
      recover(attempt,retryAfterUntil - Date.now());return;
    }
    var mine = ++generation, m = market(), customerEpoch = customerContextEpoch;
    var matchingRenewal = false;
    clearFallbackReceipt();if (state.status === 'unavailable') render();
    if (controller && (!pendingRequest || pendingRequest.controller !== controller)) controller.abort();
    if (!active()) {state = {status:'idle',quote:null};shippingQuote(null,null,'checkout_required');render();return;}
    controller = new AbortController();var requestController = controller, signal = requestController.signal;
    var timeout = setTimeout(function () {requestController.abort();},8000);
    function isCurrent() {
      var now = market();
      return mine === generation && m.country === now.country && m.currency === now.currency;
    }
    async function readCart() {
      var url = (window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js?country=' + encodeURIComponent(m.country);
      for (var read = 0; read < 2; read++) {
        if (!isCurrent()) return null;
        if (signal.aborted) throw new Error('timeout');
        try {
          var response = await fetch(url,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'},signal:signal});
          if (!response.ok) {
            var unavailable = new Error('cart');
            unavailable.cartRetryable = unavailable.retryable = response.status === 408 || response.status === 429 || response.status >= 500;
            if (response.status === 429) {retryAfterUntil = Math.max(retryAfterUntil,rateLimitDeadline(response));throw unavailable;}
            throw unavailable;
          }
          var cart = await response.json();
          if (!isCurrent()) return null;
          if (signal.aborted) throw new Error('timeout');
          if (!cart || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0 || !Array.isArray(cart.items)) throw new Error('context');
          // Markets can briefly return the previous currency. Re-read the
          // selected country once, inside this generation's original deadline.
          if (cart.currency !== m.currency) {var stale = new Error('context');stale.cartRetryable = true;throw stale;}
          return cart;
        } catch (error) {
          if (read !== 0 || !isCurrent() || signal.aborted || Date.now() < retryAfterUntil || (error.name !== 'TypeError' && error.cartRetryable !== true)) {
            if (error.name === 'TypeError' || error.name === 'AbortError') error.retryable = true;
            throw error;
          }
        }
      }
    }
    try {
      var cart = await readCart();
      if (!cart || mine !== generation) return;
      for (var receiptRead = 0; receiptRead < 2 && !drawerMatchesCart(cart); receiptRead++) {
        await syncDrawerReceipt(cart,signal);
        if (!isCurrent()) return;
        cart = await readCart();
        if (!cart || !isCurrent()) return;
      }
      if (!drawerMatchesCart(cart)) throw new Error('context');
      if (!cart.items.length) {state = {status:'idle',quote:null};shippingQuote(null,0,'checkout_required');render();return;}
      fallbackReceipt = {cart:cart,country:m.country,currency:m.currency,customerEpoch:customerEpoch,expiresAt:Date.now() + 60000};
      fallbackExpiryTimer = setTimeout(function () {clearFallbackReceipt();render();},60000);
      var codes = [], lines = [], unsupported = false, itemCount = 0;
      (cart.cart_level_discount_applications || []).forEach(function (d) {if (d.type === 'discount_code') codes.push(d.title);});
      cart.items.forEach(function (item) {
        itemCount += item.quantity;
        var properties = quoteProperties(item);
        if (item.selling_plan_allocation || item.gift_card || item.parent_relationship || properties === null) unsupported = true;
        (item.line_level_discount_allocations || []).forEach(function (a) {if (a.discount_application && a.discount_application.type === 'discount_code') codes.push(a.discount_application.title);});
        var existing = lines.find(function (l) {return l.variantId === String(item.variant_id);});
        if (existing) {
          if (JSON.stringify(existing.properties || {}) !== JSON.stringify(properties || {})) unsupported = true;
          else existing.quantity += item.quantity;
        } else {
          var line = {variantId:String(item.variant_id),quantity:item.quantity};
          if (properties && Object.keys(properties).length) line.properties = properties;
          lines.push(line);
        }
      });
      if (unsupported) throw new Error('unsupported');
      codes = Array.from(new Set(codes)).sort();lines.sort(function (a,b) {return a.variantId.localeCompare(b.variantId);});
      var input = {country:m.country,currency:m.currency,subtotalCents:cart.total_price,lines:lines,discountCodes:codes};
      var key = JSON.stringify(input);
      var included = cart.duties_included === true;
      if (renewal) {
        if (renewal.key !== key || renewal.included !== included) {invalidate();schedule(false);return;}
        matchingRenewal = true;
      }
      if (!renewal && lastGood && lastGood.key === key && lastGood.included === included && Date.now() < lastGood.validUntil) {lastGood.receipt = cart;useQuote(lastGood,itemCount);return;}
      if (!matchingRenewal && !(recovering && state.status === 'unavailable')) {state = {status:'pending',quote:null};shippingQuote(null,itemCount,'pending');render();}
      else if (!matchingRenewal) render();
      // An obsolete basket must not consume the current basket's deadline.
      // Core bounds any native overlap; identical current requests still join.
      if (pendingRequest && (pendingRequest.key !== key || pendingRequest.customerEpoch !== customerEpoch)) {
        var obsolete = pendingRequest;pendingRequest = null;
        obsolete.controller.abort();
      }
      // Preserve any cooldown already established by a provider response.
      if (Date.now() < retryAfterUntil) {recover(attempt,retryAfterUntil - Date.now());return;}
      var request = pendingRequest;
      if (!request) {
        if (signal.aborted) throw new Error('timeout');
        // Cart reads and drawer reconciliation have their own bounded phase.
        // Give this fresh provider request its full budget; never renew a join.
        clearTimeout(timeout);timeout = setTimeout(function () {requestController.abort();},8000);
        request = {key:key,customerEpoch:customerEpoch,controller:requestController,sentAt:Date.now()};
        pendingRequest = request;
        var quoteOptions = {method:'POST',headers:{'Content-Type':'application/json'},body:key,signal:signal,credentials:'same-origin',redirect:'error'};
        request.promise = fetch('/apps/availability/signup?action=cart-quote',quoteOptions).then(function (response) {
          // A missing proxy can use the existing anonymous route for a basket
          // without codes. Never downgrade a declined customer-qualified quote.
          if (!codes.length && (response.status === 404 || response.status === 405)) {
            if (signal.aborted) throw new Error('timeout');
            if (customerEpoch !== customerContextEpoch) throw new Error('context');
            return fetch('https://core.dsrcv.com/api/shopify/storefront-duties-estimate',Object.assign({},quoteOptions,{credentials:'omit'}));
          }
          return response;
        }).then(async function (response) {
          if (!response.ok) {
            var unavailable = new Error('quote');unavailable.retryable = response.status === 408 || response.status === 429 || response.status >= 500;
            if (response.status === 429) retryAfterUntil = Math.max(retryAfterUntil,rateLimitDeadline(response));
            throw unavailable;
          }
          return response.json();
        }).catch(function (error) {
          if (error.name === 'TypeError' || error.name === 'AbortError') error.retryable = true;
          throw error;
        });
        var clearRequest = function () {if (pendingRequest === request) pendingRequest = null;};
        request.promise.then(clearRequest,clearRequest);
      }
      var data = await request.promise, sentAt = request.sentAt;
      if (mine !== generation) return;
      if (!data || typeof data !== 'object' || Array.isArray(data)) throw new Error('reconciliation');
      var q = data.quote, expectImport = !!importMarkets[m.country];
      if (data.available !== true || !q || q.referenceLocation !== true || q.country !== m.country || q.currency !== m.currency || q.subtotalCents !== cart.total_price || !Number.isSafeInteger(q.shippingCents) || q.shippingCents < 0 || typeof q.shippingService !== 'string' || !q.shippingService.trim() || q.dutiesEstimated !== expectImport) throw new Error('reconciliation');
      if (expectImport ? !Number.isSafeInteger(q.importChargesCents) || q.importChargesCents < 0 || q.totalCents !== cart.total_price + q.shippingCents + q.importChargesCents : q.importChargesCents !== null || q.totalCents !== null) throw new Error('reconciliation');
      var validFor = data.expiresInMs - (Date.now() - sentAt);
      if (!Number.isSafeInteger(data.expiresInMs) || data.expiresInMs > 60000) throw new Error('expired');
      if (validFor <= 0) {var expired = new Error('expired');expired.retryable = true;throw expired;}
      var quoteId = typeof data.quoteId === 'string' && /^[a-f0-9-]{36}$/i.test(data.quoteId) ? data.quoteId : null;
      if (renewal && (!quoteId || quoteId === renewal.quoteId)) {
        if (quoteId !== renewal.quoteId || JSON.stringify(q) !== JSON.stringify(renewal.quote)) throw new Error('reconciliation');
        renewal.validUntil = Math.min(renewal.validUntil,Date.now() + validFor);
        useQuote(renewal,itemCount,false);return;
      }
      lastGood = {key:key,included:included,validUntil:Date.now() + validFor,status:included ? 'included' : expectImport ? 'ready' : 'shipping_only',quote:q,quoteId:quoteId,receipt:cart};
      useQuote(lastGood,itemCount);
    } catch (error) {if (mine === generation) {
      if (matchingRenewal && isCurrent() && lastGood === renewal && Date.now() < validUntil && drawerMatchesCart(renewal.receipt)) {
        // The original hard-expiry timer remains armed. No old deadline moves.
        return;
      }
      // Aborting this browser request cannot cancel an already running Shopify
      // calculation. A dropped connection or browser deadline needs the same
      // recovery as a busy server, without a cart mutation or click. Back off
      // progressively instead of exhausting a single retry. A rate-limit
      // cooldown also survives cart events and the manual retry button.
      // Never retry rejected basket context or display unverified amounts.
      var transient = error.retryable === true || error.message === 'timeout';
      if (transient) {
        state = {status:'unavailable',quote:null};shippingQuote(null,null,'error');render();
        recover(attempt + 1,[6250,15000,30000,60000][Math.min(attempt,3)]);
      } else {state = {status:'unavailable',quote:null};shippingQuote(null,null,error.message === 'unsupported' ? 'checkout_required' : 'error');render();}
    }}
    finally {clearTimeout(timeout);}
  }
  function schedule(changed) {if (changed) invalidate();else render();clearTimeout(timer);timer = setTimeout(function () {refresh(0);},250);}
  window.dsrcvCartDutiesPreview = {render:render,getState:function () {retireExpiredQuote();return state;},getCheckoutFallback:checkoutFallback};
  ['cart:refresh','cart:updated','cart:request:success','cart:change','currency:change','covCurrency:updated','product:added','native-ucd:product-added','dsrcv:preview-shipping-requested'].forEach(function (name) {document.addEventListener(name,function () {
    if (name === 'cart:refresh' && dispatchingDrawerSync || name === 'dsrcv:preview-shipping-requested' && drawerSync) return;
    schedule(true);
  });});
  document.addEventListener('click',function (event) {
    if (active() && event.target.closest && event.target.closest('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]')) schedule(true);
  },true);
  // The full cart replaces its form after quantity changes and signals the
  // loading lifecycle rather than the drawer's cart events.
  document.addEventListener('theme:loading:start',function () {
    if (document.querySelector('.Cart__Recap')) {fullCartLoading = true;clearTimeout(timer);invalidate();}
  });
  document.addEventListener('theme:loading:end',function () {
    if (fullCartLoading || document.querySelector('.Cart__Recap')) {fullCartLoading = false;schedule(true);}
  });
  document.addEventListener('dsrcv:cart-shipping-updated',render);
  var observer = new MutationObserver(function (records) {if (records.some(function (r) {return r.type === 'childList';})) render();});
  observer.observe(document.body,{childList:true,subtree:true});
  window.addEventListener('pagehide',function () {generation++;clearFallbackReceipt();clearTimeout(timer);clearTimeout(expiryTimer);clearTimeout(renewalTimer);if (controller) controller.abort();if (pendingRequest && pendingRequest.controller !== controller) pendingRequest.controller.abort();observer.disconnect();});
  document.addEventListener('visibilitychange',function () {
    if (document.visibilityState !== 'visible') {customerContextAway = true;return;}
    restoreCustomerContext();
  });
  window.addEventListener('blur',function () {customerContextAway = true;});
  window.addEventListener('focus',restoreCustomerContext);
  window.addEventListener('online',function () {if (recovering) recover(recoveryAttempt,0);});
  window.addEventListener('pageshow',function () {
    observer.observe(document.body,{childList:true,subtree:true});
    customerContextAway = document.visibilityState === 'hidden' || !document.hasFocus();refreshCustomerContext();
  });
  schedule(true);
})();
